import React from 'react';
import { IconProps } from '.';

const SvgBulb = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M4 9a7.999 7.999 0 0 0 4.25 7.068v3.682h7.5v-3.682A8 8 0 1 0 4 9Zm10.25 6.1A6.502 6.502 0 0 0 12 2.5a6.5 6.5 0 0 0-2.25 12.6v3.15h4.5V15.1Z'
        clipRule='evenodd'
      />
      <path fill={color} d='M13 23a2 2 0 0 0 2-2H9a2 2 0 0 0 2 2h2Z' />
    </svg>
  );
};

export default SvgBulb;
